import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";

import Landing from "@/pages/Landing";
import KannadaPurohitLanding from "@/pages/KannadaPurohitLanding";
import OccasionsPage from "@/pages/OccasionsPage";
import TraditionsPage from "@/pages/TraditionsPage";
import PurohithsPage from "@/pages/PurohithsPage";
import AstrologyPage from "@/pages/AstrologyPage";
import ParayanaPage from "@/pages/ParayanaPage";
import StotraHub from "@/pages/stotras/StotraHub";
import StotraPage from "@/pages/stotras/StotraPage";
import FestivalHub from "@/pages/festivals/FestivalHub";
import FestivalPage from "@/pages/festivals/FestivalPage";
import AdminChats from "@/pages/AdminChats";
import AdminApp from "@/admin/AdminApp";
import CustomerApp from "@/customer/CustomerApp";
import PriestApp from "@/priest/PriestApp";
import RitualsHub from "@/pages/RitualsHub";
import RitualPage from "@/pages/RitualPage";
import BlogHub from "@/pages/blog/BlogHub";
import BlogPost from "@/pages/blog/BlogPost";
import LocationsHub from "@/pages/locations/LocationsHub";
import LocationPage from "@/pages/locations/LocationPage";
import InvoiceSample from "@/pages/InvoiceSample";
import PatashalaPage from "@/pages/PatashalaPage";
import SringeriPage from "@/pages/heritage/SringeriPage";
import ContactPage from "@/pages/ContactPage";
import PanchangaPage from "@/pages/PanchangaPage";
import HeritagePage from "@/pages/HeritagePage";
import ImpactPage from "@/pages/ImpactPage";
import { ChatWidget } from "@/components/ChatWidget";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/occasions" element={<OccasionsPage />} />
          <Route path="/traditions" element={<TraditionsPage />} />
          <Route path="/purohiths" element={<PurohithsPage />} />
          <Route path="/astrology" element={<AstrologyPage />} />
          <Route path="/parayana" element={<ParayanaPage />} />
          <Route path="/stotras" element={<StotraHub />} />
          <Route path="/stotras/:slug" element={<StotraPage />} />
          <Route path="/festivals" element={<FestivalHub />} />
          <Route path="/festivals/:slug" element={<FestivalPage />} />
          <Route path="/kn/purohit" element={<KannadaPurohitLanding />} />
          <Route path="/kn" element={<KannadaPurohitLanding />} />
          <Route path="/admin/chats" element={<AdminChats />} />
          <Route path="/admin/*" element={<AdminApp />} />
          <Route path="/app/*" element={<CustomerApp />} />
          <Route path="/priest/*" element={<PriestApp />} />
          <Route path="/rituals" element={<RitualsHub />} />
          <Route path="/rituals/:slug" element={<RitualPage />} />
          <Route path="/blog" element={<BlogHub />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/locations" element={<LocationsHub />} />
          <Route path="/locations/:slug" element={<LocationPage />} />
          <Route path="/invoice-sample" element={<InvoiceSample />} />
          <Route path="/patashala" element={<PatashalaPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/panchanga" element={<PanchangaPage />} />
          <Route path="/heritage" element={<HeritagePage />} />
          <Route path="/impact" element={<ImpactPage />} />
          <Route path="/heritage/sringeri" element={<SringeriPage />} />
          <Route path="/patashala/sringeri" element={<SringeriPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <SiteChatWidget />
      </BrowserRouter>
    </div>
  );
}

// Hide the public chatbot on admin routes
function SiteChatWidget() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin") || pathname.startsWith("/app") || pathname.startsWith("/priest") || pathname.startsWith("/invoice-sample")) return null;
  return <ChatWidget />;
}

export default App;
